export default __webpack_public_path__ + "static/software-strategy-hero@2x-d973db235dd206af16ecc91ce3475a23.png";